<template>
<div>edit</div>
</template>

<script>
export default {
  name: 'EditOrgReservation',
}
</script>

<style scoped>

</style>
